import { apiClient } from '../lib/apiClient';

export const postWeeklyReport = async (payload: any, signal?: AbortSignal) => {
  const res = await apiClient.post('/weekly-report-input-new', payload, { signal });
  return res.data;
};

export const postWeeklyReportOverwrite = async (payload: any, signal?: AbortSignal) => {
  const res = await apiClient.post('/weekly-report-overwrite-edit', payload, { signal });
  return res.data;
};

export const postWeeklyReportDelete = async (payload: any, signal?: AbortSignal) => {
  // 削除API: POST /weekly-roport-overwrite-delete
  const res = await apiClient.post('/weekly-roport-overwrite-delete', payload, { signal });
  return res.data;
};

// バージョン新規作成API: POST /weekly_report_new_version
export const postNewWeeklyReportVersion = async (payload: any, signal?: AbortSignal) => {
  const res = await apiClient.post('/weekly_report_new_version', payload, { signal });
  return res.data;
};

export const postWeeklyReportRemand = async (payload: any, signal?: AbortSignal) => {
  // 削除API: POST /weekly-roport-remand
  const res = await apiClient.post('/weekly-roport-remand', payload, { signal });
  return res.data;
};
